var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShuffleLogoLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 111,
  height: 28,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shuffle-logo-light_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M111 16.121c0-3.943-3.113-7.03-7.085-7.03s-7.072 3.09-7.072 7.03 3.106 7.033 7.072 7.033c2.186 0 4.195-.939 5.519-2.576.311-.385.376-.905.17-1.357a1.23 1.23 0 0 0-1.114-.724h-.085c-.397 0-.774.2-1.013.54-.783 1.107-2.045 1.739-3.464 1.739-2.114 0-3.962-1.525-4.391-3.623a.08.08 0 0 1 .016-.07c.01-.01.026-.03.059-.03h10.71a.6.6 0 0 0 .436-.18c.255-.267.245-.732.245-.752m-2.838-1.238s-.029.03-.059.03h-8.432a.07.07 0 0 1-.059-.03.08.08 0 0 1-.013-.07c.531-2.055 2.232-3.382 4.332-3.382 2.101 0 3.717 1.327 4.248 3.383q.008.05-.013.069M37.176 12.85c-2.645-.33-4.283-.846-4.283-2.42 0-1.678 1.29-2.603 3.637-2.603 1.72 0 2.956.688 3.307 1.841.177.58.688.972 1.281.972a1.33 1.33 0 0 0 1.069-.537c.249-.333.324-.754.21-1.15-.646-2.213-2.773-3.537-5.686-3.537-4.113 0-6.473 1.894-6.473 5.198 0 3.485 3.536 4.028 5.88 4.39h.032c2.94.548 4.43 1.154 4.43 2.962s-1.444 2.76-4.299 2.76c-1.796 0-3.398-.978-3.814-2.325a1.3 1.3 0 0 0-1.252-.92c-.43 0-.82.202-1.069.551s-.314.784-.18 1.19c.63 1.89 2.609 3.906 6.28 3.906 4.384 0 7.002-1.93 7.002-5.162 0-4.035-3.939-4.734-6.069-5.112zM51.599 9.698A6.28 6.28 0 0 0 47.63 11.1a.13.13 0 0 1-.138.017.13.13 0 0 1-.072-.116l.01-4.272a1.31 1.31 0 0 0-1.31-1.318c-.722 0-1.312.59-1.312 1.318V21.8c0 .732.59 1.325 1.318 1.325a1.32 1.32 0 0 0 1.317-1.325v-5.857c0-2.27 1.553-3.857 3.775-3.857 2.553 0 3.641 1.18 3.641 3.943v5.758c0 .732.59 1.325 1.318 1.325h.013a1.32 1.32 0 0 0 1.317-1.325V15.98c0-4.167-1.986-6.282-5.908-6.282M89.456 7.135h.465c.309.017.597-.112.813-.33.22-.217.338-.507.338-.813 0-.632-.511-1.146-1.14-1.146h-.941c-2.76 0-4.342 1.769-4.342 4.855v.366h-6.306V9.76c0-1.792.682-2.628 2.147-2.628h.465l.01.003c.302 0 .587-.119.803-.333.22-.217.338-.507.338-.813 0-.633-.512-1.147-1.14-1.147h-.928c-1.623 0-4.343.63-4.343 4.856v.365h-1.373c-.652 0-1.183.534-1.183 1.19s.531 1.189 1.183 1.189h1.373v9.349c0 .73.594 1.33 1.324 1.33s1.324-.596 1.324-1.33v-9.35h6.306v9.35c0 .73.593 1.33 1.333 1.33.741 0 1.324-.596 1.324-1.33v-9.35h2.524c.652 0 1.183-.533 1.183-1.188 0-.656-.531-1.19-1.183-1.19h-2.534v-.306c0-1.769.708-2.629 2.16-2.629zM93.952 5.383a1.32 1.32 0 0 0-1.317 1.324V21.8c0 .732.59 1.325 1.317 1.325.728 0 1.318-.593 1.318-1.325V6.708a1.32 1.32 0 0 0-1.318-1.324M70.465 9.098c-.727 0-1.317.597-1.317 1.325v6.097c0 2.817-1.19 4.183-3.638 4.183s-3.628-1.37-3.628-4.183v-6.097c0-.732-.593-1.325-1.317-1.325s-1.318.597-1.318 1.325v6.16c0 4.193 2.226 6.506 6.266 6.506 4.041 0 6.276-2.31 6.276-6.506v-6.16c0-.732-.593-1.325-1.317-1.325z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-light_svg__b)",
  d: "M21.279 14.745a1.72 1.72 0 0 0 1.717-1.727c0-.477-.194-.909-.502-1.222a1.7 1.7 0 0 0-.767-.444L5.81 6.712a3.1 3.1 0 0 0-.924-.118 2.86 2.86 0 0 0-1.88.784 2.9 2.9 0 0 0-.902 1.825c-.072.718.115 1.512.655 2.286.57.517 1.183.794 1.78.883l16.74 2.368z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-light_svg__c)",
  d: "M19.39 22.354c1.043 0 1.889-.85 1.889-1.898a1.866 1.866 0 0 0-1.77-1.89l-16.87-1.097A2.647 2.647 0 0 0 0 20.12a2.647 2.647 0 0 0 2.638 2.652l16.75-.418z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-light_svg__d)",
  d: "M17.094 2.784A1.564 1.564 0 0 0 16.127 0c-.302 0-.58.086-.82.237L3.634 6.927A2.91 2.91 0 0 0 2.088 9.5 2.9 2.9 0 0 0 4.98 12.41c.744 0 1.439-.283 1.97-.748z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-light_svg__e)",
  d: "M21.882 14.633a1.725 1.725 0 0 0 1.114-1.615c0-.952-.77-1.726-1.717-1.726a1.8 1.8 0 0 0-.617.116L1.914 17.574A2.65 2.65 0 0 0 0 20.124a2.645 2.645 0 0 0 2.638 2.652c.4 0 .78-.093 1.118-.254l18.122-7.89z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#shuffle-logo-light_svg__f)",
  d: "M20.233 22.156a1.9 1.9 0 0 0 1.046-1.696 1.893 1.893 0 0 0-1.888-1.898c-.485 0-.928.185-1.262.488L9.15 26.49a.82.82 0 0 0-.363.686c0 .454.367.823.82.823a.8.8 0 0 0 .465-.148z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-light_svg__b",
  x1: 12.542,
  x2: 12.542,
  y1: 6.595,
  y2: 23.978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D12C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3F0A8F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-light_svg__c",
  x1: 10.641,
  x2: 10.641,
  y1: 6.585,
  y2: 24.373,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D12C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3F0A8F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-light_svg__d",
  x1: -0.839,
  x2: 16.74,
  y1: 13.608,
  y2: 1.363,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E300FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#217BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F0B1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-light_svg__e",
  x1: 4.87,
  x2: 23.587,
  y1: 20.993,
  y2: 7.957,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E300FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#217BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F0B1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shuffle-logo-light_svg__f",
  x1: 9.015,
  x2: 24.638,
  y1: 27.763,
  y2: 16.882,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E300FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#217BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F0B1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "shuffle-logo-light_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h111v28H0z"
})))));
export default SvgShuffleLogoLight;